export default {
	name: 'UsersView'
}